module.exports = __webpack_public_path__ + "b4f2d170a55ef8f711322c23f1d711a3.pdf";